// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e9e56069","453":"b78d59bb","455":"7ba0fb98"}[chunkId] + ".chunk.js";
};